<div class="modal-header">
    <h4 class="modal-title" id="myModalLabel1">Referans {{referenceId ? 'Güncelle' : "Ekle"}}</h4>
    <button type="button" class="close" (click)="closeModal()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body" tabindex="0" ngbAutofocus>
    <form [formGroup]="referenceForm">
        <div class="row">
            <div class="col-6">
                <label for="min">Min</label>
                <div class="form-group">
                    <div class="input-group">
                        <input type="number" class="form-control" id="min" formControlName="min" />
                    </div>
                    <div *ngIf="referenceForm.get('min').invalid && referenceForm.get('min').touched"
                        class="text-danger">
                        min değer zorunludur.
                    </div>
                </div>
            </div>
            <div class="col-6">
                <label for="max">Max</label>
                <div class="form-group">
                    <div class="input-group">
                        <input type="number" class="form-control" id="max" formControlName="max" />
                    </div>
                    <div *ngIf="referenceForm.get('max').invalid && referenceForm.get('max').touched"
                        class="text-danger">
                        max değer zorunludur.
                    </div>
                </div>
            </div>
        </div>

        <div>
            <label for="description">Birim</label>
            <div class="form-group">
                <ng-select [items]="unitTypes" bindLabel="unitTypeName" bindValue="id" formControlName="unitTypeId"
                    (search)="getAllUnitTypes($event)">
                </ng-select>
                <div *ngIf="referenceForm.get('unitTypeId').invalid && referenceForm.get('unitTypeId').touched"
                    class="text-danger">
                    Referans birimi gerekmektedir.
                </div>
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="closeModal()" rippleEffect>
        İptal
    </button>
    <button type="button" class="btn btn-primary" [disabled]="referenceForm.invalid" rippleEffect (click)="onSubmit()">
        {{referenceId ? 'Güncelle' : 'Ekle'}}
    </button>
</div>